<script setup>
import { computed, ref } from "vue";
import GraphCard from "./GraphCard.vue";
import fetchData from "@/utils/fetchData";
import { count, dollars, everyDay, weekChange } from "@/utils/format";

const users = ref({ totalUsers: 0, usersOverDays: [] });
const journeys = ref({ totalJourneys: 0, journeysOverDays: [] });
const cost = ref({ totalCost: 0, costOverDays: [] });

fetchData("getUserData").then((data) => (users.value = data));
fetchData("getJourneyData").then((data) => (journeys.value = data));
fetchData("getCostData").then((data) => (cost.value = data));

const usersSeries = computed(() => everyDay(users.value.usersOverDays));
const journeysSeries = computed(() =>
  everyDay(journeys.value.journeysOverDays)
);
// The API gives cost per day in cents
const costSeries = computed(() =>
  everyDay(cost.value.costOverDays).map((point) => ({
    x: point.x,
    y: point.y / 100,
  }))
);

const usersWeek = computed(() => weekChange(usersSeries.value));
const journeysWeek = computed(() => weekChange(journeysSeries.value));
const costWeek = computed(() => weekChange(costSeries.value));
</script>

<template>
  <section class="container mx-auto px-4 pt-6 pb-3">
    <div class="grid gap-4 md:grid-cols-3">
      <GraphCard
        title="People"
        note="All time"
        :value="count(users.totalUsers)"
        :series="usersSeries"
        :format="(value) => `${count(value)} making`"
        :this-week="count(usersWeek.thisWeek)"
        :change="usersWeek.change"
        :good-when-up="true"
      />
      <GraphCard
        title="Makes"
        note="All time"
        :value="count(journeys.totalJourneys)"
        :series="journeysSeries"
        :format="(value) => `${count(value)} started`"
        :this-week="count(journeysWeek.thisWeek)"
        :change="journeysWeek.change"
        :good-when-up="true"
      />
      <GraphCard
        title="AI cost"
        note="All time"
        :value="dollars(cost.totalCost)"
        :series="costSeries"
        :format="dollars"
        :this-week="dollars(costWeek.thisWeek)"
        :change="costWeek.change"
      />
    </div>
  </section>
</template>
